import { ViewModel } from '@descomplica/microfrontend-core';
import { action, makeAutoObservable, observable } from 'mobx';

import { GetUserApplicationsCollaboration } from '@/modules/platform/application/collaborations/get-user-applications.collaboration';
import { ApplicationDto } from '@/shared/application/interfaces/pegasus-io.gateway';
import { MicrofrontendViewModel } from '@/shared/presentation/Microfrontend.vm';

type Greeting = {
  icon: string;
  message: string;
};

@ViewModel()
export class HomeViewModel {
  @observable hasError = false;
  @observable isLoading = true;
  @observable applications: ApplicationDto[] = [];

  constructor(
    private microfrontendViewModel: MicrofrontendViewModel,
    private getUserApplicationsCollaboration: GetUserApplicationsCollaboration,
  ) {
    makeAutoObservable(this);
  }

  @action
  async onInit() {
    try {
      this.isLoading = true;

      const { data } = await this.getUserApplicationsCollaboration.run();
      this.applications = data;

      if (this.accountGrants.canSkipApplicationSelection) {
        this.openApplication(this.applications[0]);
      }
    } catch (error) {
      this.hasError = true;
    } finally {
      this.isLoading = false;
    }
  }

  openApplication(application: ApplicationDto) {
    window.open('https://' + application.baseURL, '_self');
  }

  openApplicationAdmin(application: ApplicationDto) {
    window.open('https://' + application.baseURL + '/admin', '_blank');
  }
  get greetingMessage(): Greeting {
    const h = new Date().getHours();
    switch (true) {
      case h <= 5:
        return { icon: '🌙', message: 'Boa madrugada' };
      case h < 12:
        return { icon: '🌤️', message: 'Bom dia' };
      case h < 18:
        return { icon: '🌥️', message: 'Boa tarde' };
      default:
        return { icon: '🌙', message: 'Boa noite' };
    }
  }

  get user() {
    return this.microfrontendViewModel.account;
  }

  get accountGrants() {
    return this.microfrontendViewModel.accountGrants;
  }
}
